module.exports = __webpack_public_path__ + "img/com.samsung.smarthome.df38653d.webp";